import type { NavbarModelProps } from '@/components/shared/navbar/navbar.model'
import { useNavbarModel } from '@/components/shared/navbar/navbar.model'
import { NavbarView } from '@/components/shared/navbar/navbar.view'

export function NavbarViewModel(props: NavbarModelProps) {
  const model = useNavbarModel(props)
  return <NavbarView {...model} />
}
